import enCompanyDemo from './en';
import ruCompanyDemo from './ru';

export default {
  en: {
    ...enCompanyDemo,
  },
  ru: {
    ...ruCompanyDemo,
  },
};
